import React, { memo, useEffect, useRef, useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import { useDispatch, connect } from 'react-redux';
import Image from "../../common/Image/ImageLazyWrapper";
import NoProductFound from '../../common/no-product-found/NoProductFound';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import UOMSliderWrapper from '../add-edit-product/UOMSliderWrapper';
import { Regex, isBeyondRange } from '../../utills';
import { getListingData,getPsvDetails } from '../../actions/products';
import FormSwitch from 'jd-library/FormSwitch';
import styles from './AddPriceCard.scss';
import Loader from '../../common/Loader/Loader';
import { setNotificationData } from './Notifications/redux/action';
import UnitCount from '../add-edit-product/unit-Count/UnitCount';
import { debounceFunc } from './addpricecard.utils';

const NoImageForTemplate = (props) => {
  const imageProps = {
    style: {
      borderRadius: '10px'
    },
    imgClass: styles['no-img-image'],
    finalImageSrc: "https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png",
    retainRandomColor: true,
  }
  return (
    <div className="no-img template-product imgHolder" onClick={() => {
      props.onClick && props.onClick()
    }}>
      <Image {...imageProps} />
    </div>
  );
};

const AddPriceCard = (props) => {
  const sliderRef = useRef(null);
  const selectedSlider = useRef(null);
  const [data, setData] = useState(() => props.pricecardData);
  const [isValidated, setIsValidated] = useState(false);
  const [currentSelectedForUom, setCurrentSelectedForUom] = useState(0) 
  const dispatch = useDispatch();
  const [scroll, setScroll] = useState(0)
  let [showLoader, setLoader] = useState(false);
  const uomDefaultOBj = props.serviceUOMDefault
  uomDefaultOBj.count = "1"

  const toggleChange = (value, index) => {
    if(props.isReadOnly) return;
    const updatedValues = [...data.productData];
    if (value) {
      updatedValues[index].showPriceRange = true;
      if (updatedValues[index].uom?.val == 'stds'){
        onSelectUOM('',uomDefaultOBj)
        uomChange('1',index,'1 Sess')
      }
    } else {
      updatedValues[index].showPriceRange = false;
      if (updatedValues[index].categoryType != "product"){
        updatedValues[index].error = '';
      }
    }
    setData(() => ({ ...data, productData: updatedValues }));
  }


  const toggleUom = (index) =>  {
    const updatedValues = [...data.productData];
    if (updatedValues[index].price || (updatedValues[index].priceObj?.minPrice && updatedValues[index].priceObj?.maxPrice)){
      updatedValues[index].customDuration = updatedValues[index].uom.val;
      updatedValues[index].customUnit = updatedValues[index].uom.count;
      setData(() => ({ ...data, productData: updatedValues }));
    }
  }

  const onChange = (e, key, isMinMax,actDisc) => {
    const { target: { value } } = e;
    if (Regex.priceRegex.test(value)) {
      let values = [...data.productData];
      let price = values[key]?.priceObj ? { ...values[key]?.priceObj } : {};
      if (isMinMax) {
        if (isMinMax === 'min') {
          price = {
            ...price,
            minPrice: value
          };
        } else{
          price = {
            ...price,
            maxPrice: value
          };
        }
      }else if (actDisc) {
        if (actDisc == 'act'){
          values[key].actualPrice = value;
        }else {
          values[key].discPrice = value;
        }
      } else {
        values[key].price = value;
      }

      if (!isMinMax) {
        values[key].error = '';
        values[key].actualPriceErr = '';
        values[key].discPriceErr = '';
      } else if (isMinMax === 'min' || isMinMax === 'max') {
        price = {
          ...price,
          minError: '',
          maxError: ''
        }
      }
      values[key].priceObj = price;
      setData(() => ({ ...data, productData: values }));
      if (Number(value) && !isValidated) {
        setTimeout(() => setIsValidated(() => true), 100);
      }
    }
  }

  const onSave = async () => {
    setLoader(true);
    let validated = 1;
    let errMsg = '';
    let updatedData = [...data.productData];
    const { default: { showMessage } } = await import('jd-library/toastMessageActions');
    const { validatedPriceCardData } = await import('./addpricecard.utils');
    const { toggleProductCardSlider } = await import('../../actions/products');
    const { default: { closeCurrent } } = await import('jd-library/historyHandler');
    for (let i = 0; i < updatedData?.length; i += 1) {
      const productdata = updatedData[i];
      let newPriceObj = {};
      if (productdata?.showPriceRange && !productdata?.priceObj?.minPrice) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.minError = 'Please enter Min Price';
        newPriceObj.maxError = productdata?.priceObj?.maxPrice === '0' || productdata?.priceObj?.maxPrice === '1' || !productdata?.priceObj?.maxPrice ? ' ' : '';
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Please enter Min Price';
        validated = 0;
      } else if (productdata?.showPriceRange && Number(productdata?.priceObj?.minPrice) === 0) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.minError = 'Minimum price Cannot be 0';
        newPriceObj.maxError = productdata?.priceObj?.maxPrice === '0' || productdata?.priceObj?.maxPrice === '1' || !productdata?.priceObj?.maxPrice ? ' ' : ''
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Minimum price Cannot be 0';
        validated = 0;
      } else if (productdata?.showPriceRange && Number(productdata?.priceObj?.minPrice) < 0.01) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {} 
        newPriceObj.minError = 'Minimum price must be at least 0.01';
        newPriceObj.maxError = productdata?.priceObj?.maxPrice === '0' || productdata?.priceObj?.maxPrice === '1' || !productdata?.priceObj?.maxPrice ? ' ' : ''
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Minimum price must be at least 0.01';
        validated = 0;
      } else if (productdata?.showPriceRange && !productdata?.priceObj?.maxPrice) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.maxError = 'Please enter Max Price';
        newPriceObj.minError = productdata?.priceObj?.minPrice === '0' || productdata?.priceObj?.minPrice === '1' ? ' ' : ''
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Please enter Max Price';
        validated = 0;
      } else if (productdata?.showPriceRange && Number(productdata?.priceObj?.maxPrice) === 0) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.maxError = 'Maximum price Cannot be 0';
        newPriceObj.minError = productdata?.priceObj?.minPrice === '0' || productdata?.priceObj?.minPrice === '1' ? ' ' : ''
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Maximum price Cannot be 0';
        validated = 0;
      } else if (productdata?.showPriceRange && Number(productdata?.priceObj?.maxPrice) < 0.01) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.maxError = 'Maximum price must be at least 0.01';
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Maximum price must be at least 0.01';
        validated = 0;
      } else if (productdata?.showPriceRange && productdata?.priceObj?.minPrice && productdata?.priceObj?.maxPrice && Number(productdata.priceObj.minPrice) >= Number(productdata.priceObj.maxPrice)) {
        newPriceObj = productdata.priceObj ? productdata.priceObj : {}
        newPriceObj.maxError = ' ';
        newPriceObj.minError = ' '
        productdata.priceObj = newPriceObj;
        errMsg = errMsg || 'Maximum Price Cannot be Same or Less Than Minimum Price';
        validated = 0;
      } else if (productdata.showPriceRange && (productdata.priceObj.maxError || productdata.priceObj.minError)) {
        errMsg = errMsg || productdata.priceObj.minError || productdata.priceObj.maxError;
        validated = 0;
      }else if (productdata?.showPriceRange && productdata?.error){
        validated = 1;
      }else if (!productdata.showPriceRange) {
        if (productdata.price && Number(productdata.price) == 0) {
          productdata.error = errMsg || 'Cannot be 0';
          errMsg = errMsg || 'Price Cannot be 0';
          validated = 0;
        } else if (productdata.price && Number(productdata.price) < 0.01) {
          productdata.error = errMsg || 'Price must be at least 0.01';
          errMsg = errMsg || 'Price must be at least 0.01';
          validated = 0;
        }

        if (productdata.actualPrice && Number(productdata.actualPrice) == 0) {
          productdata.actualPriceErr = errMsg || 'Actual Price Cannot be 0';
          errMsg = errMsg || 'Actual Price Cannot be 0';
          validated = 0;
        } else if (productdata.actualPrice && Number(productdata.actualPrice) < 0.01) {
          productdata.actualPriceErr = errMsg || 'Actual Price must be at least 0.01';
          errMsg = errMsg || 'Actual Price must be at least 0.01';
          validated = 0;
        } else {
          productdata.actualPriceErr = ""
        }

        if (productdata.discPrice && Number(productdata.discPrice) == 0) {
          productdata.discPriceErr = errMsg || 'Discount Price Cannot be 0';
          errMsg = errMsg || 'Discount Price Cannot be 0';
          validated = 0;
        } else if (productdata.discPrice && Number(productdata.discPrice) < 0.01) {
          productdata.discPriceErr = errMsg || 'Discount Price must be at least 0.01';
          errMsg = errMsg || 'Discount Price must be at least 0.01';
          validated = 0;
        } else {
          productdata.discPriceErr = ""
        }

        if (productdata.actualPrice && productdata.discPrice && Number(productdata.discPrice) > Number(productdata.actualPrice)) {
          productdata.actualPriceErr = errMsg || 'Disc.Rs. cannot be greater than Actual Rs.';
          productdata.discPriceErr = errMsg || 'Disc.Rs. cannot be greater than Actual Rs.';
          errMsg = errMsg || 'Discount Price cannot be greater than Actual Price';
          validated = 0;
        }

      }else if (productdata.error) {
        validated = 0;
        errMsg = errMsg || productdata.error;
      }
      if (validated) {
        if (productdata.categoryType == 'service' && productdata.actualPrice && !productdata.discPrice) {
          productdata.discPrice = productdata.actualPrice
        } else if (productdata.categoryType == 'service' && productdata.discPrice && !productdata.actualPrice) {
          productdata.actualPrice = productdata.discPrice
        }
      } else if(productdata.categoryType == 'service' && validated == 1) {
        errMsg = productdata.priceObj.minError = productdata.priceObj.maxError = '';  
      }
      updatedData[i] = productdata;
    }
    if (!validated) {
      setData(() => ({ ...data, productData: updatedData }));
      dispatch(showMessage({
        showToastMessage: true,
        message: errMsg,
        type: 'error',
        duration: 2000
      }))
      setLoader(false);
    } else {
      const { success, error, errData=null } = await validatedPriceCardData(data.productData);
      if (success) {
        setTimeout(() => closeCurrent(), 100);
        dispatch(showMessage({
          showToastMessage: true,
          message: `Price Updated for ${success}  ${success > 1 ? props?.session?.profileObject?.PluralLabelWithSpace : props?.session?.profileObject?.SingleLabelWithSpace}`,
          type: 'info',
          duration: 2000
        }));
        dispatch(setNotificationData({ token: props.session.token }));
        dispatch(toggleProductCardSlider(false));
        dispatch(getListingData({ tabKey: undefined, filterObj : props.filterProductObj }))
        setLoader(false);
      } else if (error) {
        if (errData?.errorType=="servicePriceTollerence" || errData?.errorType=="productPriceTollerence") {
          errData?.priceRange?.map((priceErrData, i) => {
            data.productData?.some((priceData, j, mainArr) => {
              if (priceData.productId==priceErrData.productId) {
                if (priceData?.showPriceRange) {
                  if (isBeyondRange(priceData?.priceObj?.minPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                    priceData.priceObj.minError = errData?.msg
                  }
                  if(isBeyondRange(priceData?.priceObj?.maxPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                    priceData.priceObj.maxError = priceData?.priceObj?.minError ? ' ' : errData?.msg;
                  }
                } else {
                  if(priceData?.price){
                    if (isBeyondRange(priceData?.price, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                      priceData.error = errData?.msg;
                    }
                  }else{
                    if (isBeyondRange(priceData?.actualPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                      priceData.actualPriceErr = errData?.msg;
                    }
                    if (isBeyondRange(priceData?.discPrice, priceErrData?.minPrice, priceErrData?.maxPrice)) {
                      priceData.discPriceErr = priceData?.actualPriceErr ? ' ' : errData?.msg;
                    }    
                  }
                }
                data.productData[j] = priceData;
                return true;
              }
            })            
          });
          setData({...data});
        }
        dispatch(showMessage({
          showToastMessage: true,
          message: error,
          type: 'error',
          duration: 2000
        }));
        setLoader(false);
      } else {
        dispatch(toggleProductCardSlider(false));
        setTimeout(() => closeCurrent(), 100);
        setLoader(false);
      }
    }
  }

  const onSelectUOM = (_, uom) => {
    if (selectedSlider.current !== null) {
      const values = [...data.productData];
      values[selectedSlider.current].uom = uom;
      if(values[selectedSlider.current].showPriceRange){
        values[selectedSlider.current].priceObj.minError = '';
        values[selectedSlider.current].priceObj.maxError = '';
      }
      setTimeout(() => setData(() => ({ ...data, productData: values })), 100);
      sliderRef.current.openCloseUOMSlider(false);
    }
  }

  const handleImageError = (e) => {
    e.target.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
  }

  const uomChange = (value, ind,uomString) => {
    const count = value || 1
    const values = [...data.productData];
    values[ind].customDuration = values[ind]?.uom?.val != 'stds' ? values[ind]?.uom?.val : uomString.split(" ")[1];
    values[ind].customUnit = count;  
    values[ind].uom.count = count;
    values[ind].unitOfMeasurement = `${count} ${uomString.split(" ")[1]}`
    setData(() => ({ ...data, productData: values }))
    toggleUom(ind)
  }

  const isUomVisible = (pricedata) => {
    const uomTypeAry = ["Session", "Visit", "Session(s)", "Visit(s)","Specific Time Duration","Specific Time Duration(s)"]
    const uomTypeArr = ["Sess","visit","stds"]
    // One for condition is here that is only for services that need to be handle using api
    if (uomTypeAry.includes(pricedata?.uom?.displayVal) || uomTypeArr.includes(pricedata?.customUnit)) {
      return true
    } else {
      return false
    }
  }
  const uomFull = (val) =>{
    if (val.toLowerCase() == 'sess' ) return "Session"
    else if  (val.toLowerCase() == 'visit') return "Visit"
    else if (val.toLowerCase() == 'stds') return "Specific Time Duration"
    else return ""
  }

  const scrollHandler = (e) => {
    if((scroll < 10 && e.target.scrollTop > 10) || e.target.scrollTop == 0){
        setScroll(e.target.scrollTop);
    }
  }


  const debouncedScrollHandler = debounceFunc(scrollHandler, 10);

  useEffect(() => {
    if(data.productData?.length && !data.isDataSet) {
      let newData = data.productData.filter(cur => {
        checkAndFillUOM(cur);
        return cur;
      });
      setData({...data,productData: newData,isDataSet: true});
    }
  },[data])

  const checkAndFillUOM = (pricedata) => {
    if(pricedata.uom) {
      let psvData = {
        type: pricedata.categoryType,
        psv_node_id: pricedata.psv_node_id,
      };
      let PsvDetailsUomType = dispatch(getPsvDetails(psvData));
      if(PsvDetailsUomType?.UNIT?.length) {
        pricedata.PsvDetailsUomType =  PsvDetailsUomType;
        let uomInPsvData = PsvDetailsUomType?.UNIT?.length ? PsvDetailsUomType.UNIT.find(cur => cur.val == pricedata.uom.val) : null;
        if(!uomInPsvData) {
          pricedata.uom = PsvDetailsUomType?.UNIT[0];
        }
      }
    }
  }




  return (
    <SliderWrapper
      header={{
        heading: 'Add Price',
        className: ` ${scroll > 10 ? "header-scrolled" : ""}`
      }}
      footer={{
        btnProps: isValidated && !props.isReadOnly &&
          [{
            children: 'Save',
            onClick: onSave,
            showLoader: showLoader,
            className: `${props.hasGlassFooter ? "add-priceCard-saveBtn" : ''}`
          }]
      }}
      onHidden={async () => {
        const { toggleProductCardSlider } = await import('../../actions/products');
        dispatch(toggleProductCardSlider(false));
      }}
      onScroll={debouncedScrollHandler}
    >

      {!data ? <Loader /> :
        <div className={`add-price-card-container ${props.hasGlassFooter ? 'ubl-price-class' : ''}`}>
          {data.productData?.length ? data.productData?.map((pricedata, i) => {        
            return (
              <div key={pricedata.productId}>
                <div className="card-item">
                  {pricedata.imageUrl.includes('http') ?
                    <div className='image-container'>
                      <img src={pricedata.imageUrl} alt="" onError={handleImageError} />
                    </div>
                    : <div className='img-holder image-place-holder'><div className='no-img imgHolder'><NoImageForTemplate /></div></div>}
                  <div className="product-data-container">
                    <div className="product-name">{pricedata.productName}</div>
                    <div className='inputgroup'>
                      {pricedata.showPriceRange ?
                        <>
                          <InputWithMovingLabel
                            label='Min Rs.'
                            errClass="errClass"
                            errorMessage={pricedata.priceObj?.minError || pricedata.priceObj?.maxError}
                            input={{
                              value: pricedata.priceObj?.minPrice || '',
                              type: 'text',
                              maxlength: 50,
                              onChange: (e) => onChange(e, i, 'min', ''),
                              className: "priceInp"
                            }}
                            holderClass={`priceContainer ${pricedata.priceObj?.minPrice ? "removeTop" : ""} ${!pricedata.priceObj?.minError && pricedata.priceObj?.maxError ? "addMaxErr" : ""} ${props.isReadOnly ? 'priceContainer-read-only-mode' : ''} `}
                          />
                          -
                          <InputWithMovingLabel
                            label='Max Rs.'
                            errClass="errClass"
                            errorMessage={pricedata.priceObj?.maxError}
                            input={{
                              value: pricedata.priceObj?.maxPrice || '',
                              type: 'text',
                              maxlength: 50,
                              onChange: (e) => onChange(e, i, 'max', ''),
                              className: "priceInp"
                            }}
                            holderClass={`priceContainer ${pricedata.priceObj?.maxPrice ? "removeTop" : ""} ${pricedata.priceObj?.maxError ? "removeMaxErr" : ""} ${props.isReadOnly ? 'priceContainer-read-only-mode' : ''} `}
                          />
                        </>
                        : (pricedata.categoryType == 'service') ?
                          <>
                            <InputWithMovingLabel
                              label='Act. Rs.'
                              errClass="errClass"
                              errorMessage={pricedata?.actualPriceErr || pricedata?.discPriceErr}
                              input={{
                                value: pricedata.actualPrice || '',
                                type: 'text',
                                maxlength: 50,
                                onChange: (e) => onChange(e, i, '', 'act'),
                                className: "priceInp"
                              }}
                            holderClass={`priceContainer ${pricedata?.actualPrice ? "removeTop" : ""} ${!pricedata?.actualPriceErr && pricedata?.discPriceErr ? "addMaxErr" : ""} ${props.isReadOnly ? 'priceContainer-read-only-mode' : ''} `}
                            />
                            <div className='act-disc-inBtwn'/>
                            <InputWithMovingLabel
                              label='Disc. Rs.'
                              errClass="errClass"
                              errorMessage={pricedata?.discPriceErr}
                              input={{
                                value: pricedata.discPrice || '',
                                type: 'text',
                                maxlength: 50,
                                onChange: (e) => onChange(e, i, '', 'disc'),
                                className: "priceInp"
                              }}
                            holderClass={`priceContainer ${pricedata?.discPrice ? "removeTop" : ""} ${pricedata?.discPriceErr ? "removeMaxErr" : ""} ${props.isReadOnly ? 'priceContainer-read-only-mode' : ''} `}
                            />
                          </> :
                          <InputWithMovingLabel
                            label='Price'
                            errClass="errClass"
                            errorMessage={pricedata.error}
                            input={{
                              value: pricedata.price,
                              type: 'text',
                              maxlength: 50,
                              onChange: (e) => onChange(e, i),
                              className: "priceInp"
                            }}
                            holderClass={`priceContainer ${pricedata.price ? "removeTop" : ""} ${props.isReadOnly ? 'priceContainer-read-only-mode' : ''} `}
                          />
                      }
                      {" / "}
                      <InputWithMovingLabel
                        label='Unit'
                        disableMovingLabel
                        rightIconClass={props.isReadOnly ? '' : pricedata.isTemplate ? "" : pricedata.uom?.displayVal ? 'icon-HDRcross' : 'icon-Next'}
                        onRightIconClick={() => {
                          if(props.isReadOnly) return;
                          if (pricedata.uom?.displayVal) {
                            let values = [...data.productData];
                            values[i].uom = null;
                            selectedSlider.current = null;

                            setCurrentSelectedForUom(i)
                            setData(() => ({ ...data, productData: values }));
                          } else {
                            selectedSlider.current = i;
                            sliderRef.current.openCloseUOMSlider(true);
                          }
                        }}
                        input={{
                          value: pricedata.uom?.displayVal || uomFull(pricedata?.customUnit),
                          type: 'text',
                          readOnly: true,
                          maxlength: 100,
                          disabled: pricedata.isTemplate,
                          onChange: () => { console.log('Unit') },
                          className: `unitInp ${pricedata.isTemplate && "disablePointer"}`,
                          onClick: () => {
                            selectedSlider.current = i;
                            setCurrentSelectedForUom(i)
                            sliderRef.current.openCloseUOMSlider(true);
                          }
                        }}
                        holderClass={`unitContainer ${props.isReadOnly ? 'unitContainer-read-only-mode' : ''} `}
                      />
                    </div>
                    {
                      isUomVisible(pricedata) ?
                        <div className={`uom-container ${(pricedata.priceObj?.minError || pricedata.priceObj?.maxError) ? 'marginAppend' : ''} ${props.isReadOnly ? 'uom-container-read-only-mode' : ''} `}>
                          <UnitCount
                            uomDetails={pricedata || ''}
                            showUnitCount={['Sess', 'Visit','stds'].includes(pricedata.customUnit)}
                            customDuration={pricedata.customDuration || ''}
                            isFromAddPrice={true}
                            uomChange={(uom,index,uomString) => uomChange(uom,index,uomString)}
                            currentIndex={i}
                            
                          />
                        </div>
                        : null
                    }
                    <div className='switch-btn'>
                      <FormSwitch
                        label='Add Price Range'
                        labelPosition={'before'}
                        labelTitleClass="switchLabel"
                        className='input-row label-row'
                        onClick={() => toggleChange(!pricedata.showPriceRange, i)}
                        checked={pricedata.showPriceRange}
                        showToggleStatus={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          }) : <NoProductFound />}
          <UOMSliderWrapper
            ref={sliderRef}
            uomType={props.session.newProfile === 3 ? 'serviceUOM' : 'productUOM'}
            onSelectUOM={onSelectUOM}
            showUOMType={"Packed"}
            isHideStds={data?.productData[currentSelectedForUom].categoryType.toLowerCase() == 'service'}
            isProduct={data?.productData[currentSelectedForUom].categoryType.toLowerCase() == 'product'}
            fromAddPrice={true}
            fromAddPricePriceRange={data?.productData[currentSelectedForUom].showPriceRange}
            productUnderEdit={data.productData[selectedSlider.current]}
          />
        </div>}
    </SliderWrapper>
  );
}

const mapToState = (state) => ({
  pricecardData: state.products.pricecardData,
  filterProductObj: state.products.filterProductObj,
  newProfile: state.session.newProfile,
  serviceUOMDefault: state?.uom?.serviceUOM.filter(x=> x.val == "Sess")[0],
	hasGlassFooter: state.session.hasGlassFooter,
  uom: state.uom,
  isReadOnly: state.session?.isReadOnly,
  uom: state.uom
})

export default memo(connect(mapToState)(AddPriceCard), () => false);